import { mapState } from 'vuex'
import _ from 'lodash'
import { Base64 } from 'js-base64'
import { gameConfigCategoryResourceType, i18nCategoryResourceType } from '@/store/creative/common/category'

export const groupMixin = {
  props: {
    category: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      maxLimit: 27
    }
  },

  computed: {
    ...mapState({
      normalResource: state => state.creative.template.templateConfig.resource || {},
      i18nResource: state => state.creative.template.i18nResource || {},
      gameConfigResource: state => state.creative.template.gameConfigResource || {},
      groupsConfig: state => state.creative.template.groupsConfig
    }),

    isI18n() {
      return this.category.resource_type === i18nCategoryResourceType
    },

    isGameConfig() {
      return this.category.resource_type === gameConfigCategoryResourceType
    },

    isNormal() {
      return this.category.resource_type === 'normal'
    },

    identify() {
      let temp
      switch (true) {
        case this.isI18n:
          temp = Base64.encode(this.category.prefix)
          break
        case this.isGameConfig:
          temp = this.category.prefix
          break
        case this.isNormal:
          temp = this.category.id
          break
        default:
          temp = 1
          break
      }
      return temp
    },

    // 获取当前分类的组合数量
    currentGroupNum() {
      let currentNum = 1
      switch (true) {
        case this.isI18n:
          currentNum = _.get(this.i18nResource, this.identify, []).length
          break
        case this.isGameConfig:
          currentNum = _.get(this.gameConfigResource, this.identify, []).length
          break
        case this.isNormal:
          currentNum = _.get(this.normalResource, this.identify, []).filter(item => {
            return item.action !== 'del'
          }).length
          break
        default:
          currentNum = 1
          break
      }
      return currentNum
    },

    /**
     * todo: 代码字支持横竖屏配置的无法支持多组合制作
     * @returns {boolean}
     */
    addable() {
      return this.groupNum / this.currentGroupNum * (this.currentGroupNum + 1) <= this.maxLimit
    },

    groupNum() {
      return this.groupsConfig.length
    }
  }
}
